module.exports = __webpack_public_path__ + "static/media/12.e0e9f372.jpg";